<template>
  <div>
    <div class="main-box p-15-xs">
        <div v-if="false" class="page-title mb_15 mb-10-xs d-flex align-center justify-between">
            <h1 class="d-flex align-center fs-16-xs py-5-xs px-10-xs m-0 fs-18">
                <span class="color-2">Histórico de pedidos</span>
            </h1>

            <p @click="search = !search" class="mr_15 m-0-xs cursor-pointer">
                <i v-show="!this.search" class="fas fa-search color-2 fs-14 mr_5"></i>
                <span v-show="this.search" class="fs-24 cursor-pointer color-2 mr_5">×</span>
            </p>
        </div>

        <div>
            <div  v-if="false" class="cards-search" :class="{'open': this.search && this.period < 3 , 'open-search': this.search && this.period > 2}">
                <div class="box-2 p_15 mb_15 mr_15 mr-0-xs">
                    <div class="row">
                        <div class="col-lg-11">
                            <div class="form-group mb_0 mt_5">
                                <label for="filterPeriod" class="label-input">Período</label>
                                <select class="form-control font-select fs-12" name="filter[period]" id="filterPeriod" v-model="period">
                                    <option value="0">Hoje</option>
                                    <option value="1">Ontem</option>
                                    <option value="2">Anteontem</option>
                                    <option value="3">Ultimos 30 dias</option>
                                    <option value="4">Ultimos 180 dias</option>
                                </select>
                                <i class="fas fa-chevron-down select-icon"></i>
                            </div>

                            <div v-if="this.period > 2" class="form-group mb_0 mt_20">
                                <label class="m-0 label-input">Busca</label>
                                <input type="search" data-customer-search="" name="" class="form-control" placeholder="Digite um nome ou número de pedido.">
                            </div>
                        </div>

                        <div class="col-lg-1">
                            <button class="w-100 btn_2 btn_sm btn-primary py_10 px_0 mt-15-xs h-100 h-auto-xs cursor-pointer">Filtrar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb_15 mr_0 mr--15-xs">
                <div class="col-6 pr_7">
                    <div class="bg-color-5 w-100 p_15 color-white text-center br-5 card-shadow">
                        <p class="fs-16 fw-900">{{aOrders.count}}</p>
                        <p class="mt_5">pedidos realizados</p>
                    </div>
                </div>
                <div class="col-6 pl_7">
                    <div class="bg-color-5 w-100 p_15 color-white text-center br-5 card-shadow">
                        <p class="fs-16 fw-900">{{Utils.convertMoney(aOrders.amount)}}</p>
                        <p class="mt_5">de faturamento</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row cards px_15">
            <div @click="orderDrawer = !orderDrawer; targetOrder = order" v-for="(order, i) in aOrders.orders" :key="i" class="col-lg-3 pl_0 pr-0-xs">
                <div class="table-card card-shadow color-4 fs-12">
                    <div class="d-flex align-center justify-between mb_15">
                        <div>
                            <p class="label order-number">#{{ order.order_id }}</p>
                        </div>
                        <div class="text-right">
                            <p class="label">Status</p>
                            <p>{{ getStatus(order.status) }}</p>
                        </div>
                    </div>
                    <div class="d-flex align-center justify-between mb_15">
                        <div>
                            <p class="label">Data</p>
                            
                            <p>{{ Utils.dateParse(order.created_at) }}</p>
                        </div>
                        <div class="text-right">
                            <p class="label">Valor</p>
                            <p>{{ Utils.convertMoney(order.total) }}</p>
                        </div>
                    </div>
                    <div>
                        <p class="label">Cliente</p>
                        <p>{{ getCustomer(order) }}</p>
                    </div>
                </div>
            </div>
            <!-- Drawer Detalhes pedido -->
            <drawer :open="orderDrawer" :title="`Pedido #${targetOrder.order_id}`">
                <orders-detail :report="true" v-if="targetOrder.id" :order="targetOrder"/>
            </drawer>
        </div>
    </div>

  </div>
</template>

<script>
import Drawer from "@/components/Drawer"
import OrderAPI from '@/api/order'
import { Status } from 'easyjs/lib/Schema/Order'
import OrdersDetail from "@/containers/Orders/OrdersDetail"
import Utils from '@/utils'
export default {
  data() {
    return {
      orderDrawer: false,
      targetOrder: {},
      Utils,
      Status,
      search: false,
      period: '',
      aOrders: {
        'orders': [
            {  
                "_id":"5d6953fe62b2b07cba09d2e3",
                "id":61,
                "payment":{  
                    "payers":[  
                    {  
                        "user":{  
                            "id":"834",
                            "email":"gui.le@outlook.com",
                            "password":"",
                            "fb_id":"",
                            "name":"Guilherme Bonafini",
                            "phone":"41998018440",
                            "birthdate":"1993-10-14",
                            "retrieve_password":"",
                            "retrieve_password_until":""
                        },
                        "paymentMethod":null,
                        "method":"MASTERCARD",
                        "amount":20,
                        "changeFor":null,
                        "status":2,
                        "aproove":1
                    }
                    ],
                    "total":11,
                    "status":1
                },
                "cart":{  
                    "catalog":{  
                    "type":"catalog",
                    "items":[  
                        {  
                            "_id":"5d3f424362b2b07b8a71fb85",
                            "ref_id":"5d3f424362b2b07b8a71fb84",
                            "type":"simple",
                            "parent":"5d3f3d2462b2b00b50479753",
                            "position":0,
                            "name":"Coca-cola",
                            "price":10,
                            "image":null,
                            "description":null,
                            "new":false,
                            "delete":false,
                            "show":true
                        }
                    ]
                    },
                    "total":10
                },
                "delivery":{  
                    "address":{  
                    "address":'Rua Murilo do Amaral, 402',
                    "city": 'Curitiba',
                    "region": 'Água verde',
                    "state": 'PR',
                    "postcode": '81000-100',
                    "geolocation": {
                        'latitude': 0.66, 'longitude': 0.89
                    }
                    },
                    "type":2,
                    "price":5, // Ignorar
                    "total":5
                },
                "gift":{  
                    "code": 'SEXTA10',
                    "value": 4
                },
                "status":2,
                "total":11,
                "subtotal":null,
                "order_id":194,
                "updated_by":834,
                "created_by":834,
                "updated_at":"2019-08-30T16:52:47.000Z",
                "created_at":"2019-08-30T16:51:10.000Z"
            }
        ],
        'count': 0,
        'amount': 0
      }
    }
  },
  methods: {
    list: () => {
      let self = this
      OrderAPI.listAll().then((response) => {
        //   self.aOrders = response._data
      })
    },
    getCustomer(order) {
        return order.payment.payers[0].user.name
    },
    getStatus(status) {
      switch(status) {
        case Status.OPENED:
          return 'Aberto'
          break;
        case Status.IN_PRODUCTION:
          return 'Em produção'
          break;
        case Status.ON_DELIVERY:
          return 'Saiu para entrega'
          break;
        case Status.FINISHED:
          return 'Finalizado'
          break;
        default:
        case Status.CANCELLED:
          return 'Cancelado'
          break;
      }
    },
  },
  components:{
    Drawer,
    OrdersDetail,
  }
}
</script>